import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Globales Scroll-Handling für SPA-Navigation:
 * - Mit Hash (/#kontakt): wartet bis der Anker gerendert ist und scrollt sanft hin
 * - Ohne Hash: scrollt bei Seitenwechsel nach oben
 */
export default function ScrollManager() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      let attempts = 0;
      let cancelled = false;
      const tryScroll = () => {
        if (cancelled) return;
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        if (attempts++ < 40) setTimeout(tryScroll, 50);
      };
      tryScroll();
      return () => { cancelled = true; };
    }
    window.scrollTo(0, 0);
  }, [pathname, hash, key]);

  return null;
}
